import { Button, Flex, Paragraph } from "@ir/ui";

interface SavedLogoPreviewProps {
  logoUrl: string;
  showPreview: boolean;
  onRemove: () => void;
}

export const SavedLogoPreview = ({
  logoUrl,
  showPreview,
  onRemove,
}: SavedLogoPreviewProps) => (
  <Flex direction="column" gap={0.5} className="mb-2">
    <Paragraph className="m-0 custom-label">Current Logo</Paragraph>
    {showPreview ? (
      <Flex align="start" gap={0.5} className="current-logo-preview">
        <img
          src={logoUrl}
          alt=""
          className="rounded border border-grey-200"
          style={{
            maxHeight: 74,
            maxWidth: "100%",
            objectFit: "contain",
          }}
        />
        <Button
          size="small"
          variant="solid"
          color="error"
          aria-label="Remove logo"
          onPress={onRemove}
          style={{ height: 18, width: 18 }}
        >
          ×
        </Button>
      </Flex>
    ) : (
      <Paragraph className="text-grey-500 font-regular m-0">
        Logo will be removed when you save empty logo fields.
      </Paragraph>
    )}
  </Flex>
);
